import React from 'react';
import { COLOR } from 'constants/colors';
import { isBtoCFlow } from '__utils/common-utils';
import { useHistory } from "react-router-dom";

interface mobileProps {
    isMobile?: boolean;
}
const CopyrightInfomration: React.FC<mobileProps> = (props: mobileProps) => {
    const history = useHistory();
    return (
        <div>
            { props.isMobile && <div className="text-center p15">
                <p style={ { margin: "0 0 10px" } }>Copyright &copy; 2022 Turtlemint Money | All Rights Reserved</p>
                <p style={ { fontSize: "12px", color: COLOR.GREY, margin: "0 0 10px" } }>
                    <span>AMFI Registered Distributor | ARN - 159953 | Date of Initial Registration - 13th Feb 2019 | ARN validity upto - 13 Feb 2028</span>
                    <br />
                    <span>Mutual Fund investments are subject to market risks, read all scheme related documents carefully.</span>
                </p>
            </div> }
            {  !props.isMobile &&
                 <footer className="footerMain NewFooter" style={ { position: "relative" } }>
                 <div className="footerINner" style={ { padding: "0 0 25px 0" } }>
                     <div className="container group">
                         <div className="footerCopyright">
                             <p>Copyright &copy; 2025 Turtlemint Mutual Funds Distributors Private Limited | All Rights Reserved | <a href="/contact-us">Contact Us</a> | <a href='privacy-policy'>Privacy</a>, <a href='terms-conditions'>Terms</a> and <a href="https://docs.turtlemintmoney.com/docs/TMF-Comission-Disclosure.pdf" target="_blank">Disclosures</a> | <a href="https://www.sebi.gov.in/">SEBI</a> | <a href="https://www.amfiindia.com/">AMFI</a> | <a href="https://www.amfiindia.com/downloads/revised-code-conduct-of-inter-mf">AMFI - Code of Conduct</a>
                             {isBtoCFlow() && <> | <a href="https://docs.turtlemintmoney.com/docs/TMF-Form-MGT-7.pdf" target='_blank'>Annual Returns</a></>}
                             </p>
                             <p>AMFI Registered Distributor | ARN - 159953 | Date of Initial Registration - 13th Feb 2019 | ARN validity upto - 13 Feb 2028</p>
                             <p>Mutual Fund investments are subject to market risks, read all scheme related documents carefully.</p>
                         </div>
                         <div style={ { clear: "both" } }></div>
                     </div>
                 </div>
             </footer>
            }

        </div>
    );
}

export default CopyrightInfomration;